module.exports = __webpack_public_path__ + "static/media/icon_yunduanheihe.b7d8250d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_yunduanheihe.svg
// module id = 133
// module chunks = 0